import React from "react";
import Button from "@material-ui/core/Button";

export default function LinkButton(props) {
  const {
    setMountTarget,
    setMountProps,
    updateParent,
    link,
    mountProps,
    text,
    disabled,
    icon,
    classes
  } = props;

  const handleClick = () => {
    setMountTarget(link);
    setMountProps(mountProps);
    updateParent("udpate");
  };

  return (
    <div class={classes}>
      <Button
        variant="contained"
        color="primary"
        fullwidth
        onClick={() => handleClick()}
        startIcon={React.createElement(icon)}
        disabled={disabled}
      >
        {text}
      </Button>
    </div>
  );
}
